import React, { useEffect, useState } from 'react';
import Img from 'gatsby-image';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { media } from '../../../utils/media-queries';
import RichText from '../../molecules/richtext';
import { useWindowSize } from '../../../hooks/useWindowSize';

const MediaCopy = ({ imageSrc, videoSrc, alt, overline, copy, type }) => {
  const size = useWindowSize();
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    if (size.width < 1024) {
      setIsMobile(true);
    } else {
      setIsMobile(false);
    }
  }, [size]);

  return (
    <StyledMediaCopy className="grid">
      {isMobile && type === 'half' && (
        <p className="overline" style={{ paddingBottom: 0 }}>
          {overline}
        </p>
      )}
      <figure
        style={{
          gridColumn: type === 'half' && (isMobile ? '1 / 25' : '1 / 14'),
        }}
      >
        {imageSrc ? (
          <Img fluid={imageSrc} alt={alt} />
        ) : (
          <video src={videoSrc} autoPlay loop muted playsInline />
        )}
      </figure>
      <div className={`${type === 'half' ? 'half' : 'full'}`}>
        {!(isMobile && type === 'half') && (
          <p className="overline">{overline}</p>
        )}
        <div className="bold-small">
          <RichText blocks={copy} />
        </div>
      </div>
    </StyledMediaCopy>
  );
};

const StyledMediaCopy = styled.section`
  margin-bottom: var(--v-spacing-L);
  position: relative;
  width: 100%;

  .overline {
    color: var(--blue);
  }

  .full {
    position: absolute;
    bottom: 0;
    left: 0;
    grid-column: 1 / 25;
    margin: var(--v-spacing-S);

    .bold-small {
      color: white;
      padding-bottom: 0;
    }
  }

  .half {
    .bold-small {
      color: var(--red);
      padding-bottom: var(--v-spacing-S);
    }
  }

  @media ${media.L} {
    height: 70vh;

    figure {
      height: 70vh;

      video {
        object-position: 0 25%;
      }
    }

    .full {
      grid-column: 1 / 18;
    }

    .half {
      grid-column: 14 / 25;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
    }
  }

  @media ${media.L} {
    .full {
      .bold-small {
        max-width: 65%;
      }
    }

    .half {
      .bold-small {
        max-width: 75%;
      }
    }
  }
`;

MediaCopy.propTypes = {
  imageSrc: PropTypes.object,
  videoSrc: PropTypes.string,
  alt: PropTypes.string,
  overline: PropTypes.string,
  copy: PropTypes.array,
  type: PropTypes.string,
};

export default MediaCopy;
